import React from 'react';

import { FilterButton as SharedFilterButton } from '../../../../shared/components/Filter';
import { FILTERS } from '../../constants';
import { useClientFilters } from '../../hooks';

const FilterButton = () => {
  const { activeFilters, clearFilters } = useClientFilters();

  return (
    <SharedFilterButton
      activeFilters={activeFilters}
      clearFilters={clearFilters}
      filters={FILTERS.client}
    />
  );
};

export default FilterButton;
